import { render, staticRenderFns } from "./create-gathering.vue?vue&type=template&id=b1b92418&"
import script from "./create-gathering.vue?vue&type=script&lang=js&"
export * from "./create-gathering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports